import React, { forwardRef, useRef, useImperativeHandle, useLayoutEffect, useMemo } from "react";
import styled from 'styled-components';
import { AwesomeQR } from 'awesome-qr';
import { loadImg, drawImg } from '@/utils';

const End = ({data, activeData, onShare}, ref) => {

  const containerRef = useRef();
  const qrRef = useRef();

  useImperativeHandle(ref, () => {
    return {
      shareContainer() {
        return containerRef.current
      }
    }
  });

  const handleSetQr = async () => {
    const url = process.env.REACT_APP_DEMAND_URL + 'active_42/outsite/' + activeData.invitationCode;
    const logoUrl = await drawImg("https://file.wogoo.com/image/activity/active_205/share-logo.png")
    const qrImgUrl = await new AwesomeQR({
      text: url,
      size: 144,
      margin: 4,
      logoImage: logoUrl,
      logoCornerRadius: 2,
      logoMargin: 2
    }).draw();
    const img = await loadImg(qrImgUrl);
    img.className = 'qr-img';
    img.style.width = '72px'
    img.style.height = '72px'
    qrRef.current.appendChild(img);
    const div = document.createElement('div')
    div.className = "qr-text"
    div.innerText = '新用户注册领奖励'
    qrRef.current.appendChild(div);
  }

  useLayoutEffect(() => {
    if (activeData.invitationCode) {
      handleSetQr();
    }
  }, [activeData]);

  const rowData = useMemo(() => {
    const row1 = [];
    const row2 = [];
    if (!!data.activeDays) {
      row1.push(<span>登录<span style={{fontSize: 14}}>{data.activeDays}</span>天</span>)
    }
    if (!!data.postsCount) {
      row1.push(<span>创作<span style={{fontSize: 14}}>{data.postsCount}</span>条</span>)
    }
    if (!!data.zanCount) {
      row1.push(<span>点赞<span style={{fontSize: 14}}>{data.zanCount}</span>次</span>)
    }

    if (!!data.userStockCount) {
      if (row1.length === 3) {
        row2.push(<span>添加自选股<span style={{fontSize: 14}}>{data.userStockCount}</span>只</span>)
      } else {
        row1.push(<span>添加自选股<span style={{fontSize: 14}}>{data.userStockCount}</span>只</span>)
      }
    }
    if (!!data.checkStockCount) {
      if (row1.length === 3) {
        row2.push(<span>查看个股<span style={{fontSize: 14}}>{data.checkStockCount}</span>只</span>)
      } else {
        row1.push(<span>查看个股<span style={{fontSize: 14}}>{data.checkStockCount}</span>只</span>)
      }
    }
    if (!!data.readColumnCount) {
      if (row1.length === 3) {
        row2.push(<span>阅读研报<span style={{fontSize: 14}}>{data.readColumnCount}</span>篇</span>)
      } else {
        row1.push(<span>阅读研报<span style={{fontSize: 14}}>{data.readColumnCount}</span>篇</span>)
      }
    }
    return { row1, row2 };
  }, [data]);

  const handleShare = (e) => {
    var rect = e.target.getBoundingClientRect();
    var yOffset = e.clientY - rect.top;
    if (yOffset < 50) {
      onShare();
    }
    
  }

  return (
    <Container className="page home-page" ref={containerRef}>
      <div className="logo-bg">
        <img className="logo-img" src="https://file.wogoo.com/image/activity/active_205/logo@2x.png" alt=""/>
      </div>
      <div className="active-wrap">
        <div className="active-row active-row1">
          {rowData.row1.map((item, idx) => {
            return <div className="active-btn" key={idx}>{item}</div>
          })}
        </div>
        <div className="active-row active-row2">
          {rowData.row2.map((item, idx) => {
            return <div className="active-btn" key={idx}>{item}</div>
          })}
        </div>
      </div>
      


      <div className="bottom-bg-wrap">
        <img className="bg-img" src="https://file.wogoo.com/image/activity/active_205/home-bottom-bg@2x.png" alt=""/>
      </div>
      <div className="end-bg-wrap">
        <img className="bg-img" src="https://file.wogoo.com/image/activity/active_205/end-bg@2x.png" alt=""/>
      </div>

      <div className="end-bar" onClick={handleShare}>
        <img className="bg-img" src="https://file.wogoo.com/image/activity/active_205/end-bar@2x.png" alt=""/>
      </div>

      <div className="end-bottom">
        <div className="end-box">
          <div className="end-title">「我的2025年度总结」</div>
          <div className="end-search">
            <div className="search-title">市值风云搜索</div>
            <div className="search-btn">
              <span>年度报告</span>
            </div>
          </div>
        </div>
        <div className="qr-wrap" ref={qrRef}></div>
      </div>
    </Container>
  )
}

const Container = styled.div`
  .active-row {
    display: flex;
    .active-btn {
      font-weight: 600;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 30px;
      margin-right: 7px;
      text-align: center;
      height: 30px;
      background: linear-gradient( 173deg, #D52417 1%, #EF1C1C 71%);
      border-radius: 15px;
      width: calc(33% - 5px);
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .active-row {
    padding: 0 20px;
  }
  .active-row1 {
   
  }
  .active-row2 {
    margin-top: 34.1vw;
  }

  .bottom-bg-wrap {
    font-size: 0;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }
  .end-bg-wrap {
    position: absolute;
    font-size: 0;
    left: 0;
    top: 0;
    width: 100%;
  }
  .active-wrap {
    position: absolute;
    left: 0;
    top: 19.2vw;
    width: 100%;
    z-index: 10;
  }
  .end-bar {
    position: absolute;
    left: 0;
    top: 77.3vw;
    width: 100%;
  }
  .end-bottom {
    position: absolute;
    z-index: 100;
    width: 100%;
    box-sizing: border-box;
    left: 0px;
    bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .end-box {
      padding-left: 13.5px;
      .end-title {
        font-weight: 500;
        font-size: 11.5px;
        color: #2C2B2B;
        line-height: 17.5px;
        margin-bottom: 6.4px;
      }
    }
    .end-search {
      height: 27px;
      background: linear-gradient( 179deg, #F59A59 0%, #DE2620 100%);
      border-radius: 13.5px;
      display: flex;
      align-items: center;
      padding: 0 6px;
      .search-title {
        font-weight: 500;
        font-size: 11.5px;
        color: #FFFFFF;
        line-height: 16.5px;
      }
      .search-btn {
        margin-left: 4px;
        font-weight: 500;
        font-size: 10px;
        color: #2C2B2B;
        line-height: 14px;
        background: #FFFFFF;
        border-radius: 6px;
        padding: 2px 6px;
      }
    }
  }
  .qr-wrap {
    padding-right: 12px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    .qr-text {
      font-size: 10px;
      margin-top: 4px;
      color: #1F1D1D;
      font-weight: 500;
      line-height: 13px;
    }
  }
`;

export default React.memo(forwardRef(End));


// WEBPACK FOOTER //
// ./src/views/activity_205/end.js